import { Mail, MessageSquare, Phone, Send, User, Zap, } from 'lucide-react';
/** Icon for a @role / @staff mention — used in the summary spine when a
 *  member or recipient was authored as a directory reference rather than a
 *  literal address. */
export const mentionIcon = User;
/** Icon by action type. Mirrors the admin's ACTION_ROW_TYPE_OPTIONS so the
 *  inspector's summary spine, the picker rows, and the catalog form all read
 *  the same symbol for the same type. Unknown types fall back to Zap. */
const ICONS = {
    EMAIL: Mail,
    SMS: MessageSquare,
    PHONE_CALL: Phone,
    TRANSFER: Phone,
    PUSH_INTEGRATION: Send,
};
export function actionTypeIcon(actionType) {
    return ICONS[actionType] ?? Zap;
}
//# sourceMappingURL=action-type-icon.js.map